/* eslint-disable max-lines-per-function */
import { initTooltip } from "common/customer/tooltip";
import productCommentTracker, { trackEvent, trackHideModal } from "../product-comment-tracker";
import apiComments from "../product-comments-api";
import "./product-comments-modal.scss";

const $getSubmitButton = () => document.querySelector(".js-submit-question");
const $getModal = () => $("#product-comments-modal");
const $getTextarea = () => document.querySelector(".js-question-input");
const $getErrorMessage = () => document.querySelector(".js-question-error-message");

const checkAvailableModal = question => {
  const $submitButton = $getSubmitButton();

  $submitButton.disabled = question.length === 0;
};

export const provideQuestion = (question = "") => {
  const trimmedQuestion = question.trim();
  $getTextarea().value = trimmedQuestion;
  $getModal().modal("show");
  checkAvailableModal(trimmedQuestion);
};

const showFormError = (error = "") => {
  const isShowError = error.length > 0;
  $getTextarea().classList.toggle("error", isShowError);
  $getErrorMessage().innerText = error;
};

const handleSendQuestion = () => {
  const $submitButton = $getSubmitButton();

  $submitButton?.addEventListener("click", () => {
    const $textarea = $getTextarea();
    const question = $textarea.value.trim();

    $submitButton.disabled = true;
    apiComments
      .addQuestion({ question })
      .then(comment => {
        const $insertPlace = document.querySelector(".js-product-comments-list");
        const $newAnswer = document.createElement("div");
        $newAnswer.innerHTML = comment;
        $insertPlace.appendChild($newAnswer.firstChild);
        initTooltip();

        $getModal().modal("hide");
        $submitButton.disabled = false;
        $textarea.value = "";
        trackEvent("product_detail_post_your_question_posted", { question });
      })
      .catch(error => {
        showFormError(error);
      });
  });
};

const handleQuestionTextarea = () => {
  const $textarea = $getTextarea();

  $textarea?.addEventListener("keyup", e => {
    const { value } = e.currentTarget;
    const trimmedValue = value.trim();

    checkAvailableModal(trimmedValue);
    showFormError(trimmedValue.length === 0 ? "Question field cannot be empty" : "");
  });
};

const initOnHideModal = () => {
  $getModal().on("hide.bs.modal", event => {
    event.stopPropagation();

    if ($getModal().is(":visible")) {
      trackHideModal();
    }
    showFormError();
  });
};

export default () => {
  handleSendQuestion();
  handleQuestionTextarea();
  initOnHideModal();
  productCommentTracker();
};
